<template>
  <div class="pluginCont">
    <p class="title_label">
      <b>插件配置</b>
      <el-select v-model="pluginId" multiple placeholder="请选择" @change="changeSelect" @remove-tag="removeTag" size="small">
        <el-option v-for="item in pluginDialogArr" :key="item.pluginId" :label="item.pluginName" :value="item.pluginId"> </el-option>
      </el-select>
    </p>
    <div class="plugin-cont">
      <ul>
        <li v-for="(item, index) in pluginArr" :key="index">
          <p class="plugin-name">
            {{ item.pluginName }}
            <el-button type="default" size="small" @click="checkDesc(item.url)">查看插件接入说明</el-button>
          </p>
          <div class="info">
            <div class="params-cont" v-for="(config, i) in item.configMapArr" :key="i">
              <span>{{ config.keyValue }}</span>
              <el-input v-model="config.val" placeholder="请输入" size="small"></el-input>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { queryAllSdkPlugin } from '@/api/sysmana.model'
export default {
  name: 'plugin',
  props: ['fromPackData'],
  data() {
    return {
      pluginArr: [],
      pluginDialogArr: [],
      pluginId: []
    }
  },
  watch: {
    fromPackData() {
      this.getPlugin()
      this.query()
    }
  },
  created() {
    this.getPlugin()
    this.query()
  },
  methods: {
    query() {
      const packData = JSON.parse(JSON.stringify(this.fromPackData))
      this.pluginArr = []
      this.pluginId = []
      if (packData.pluginVoList) {
        packData.pluginVoList.forEach((item) => {
          this.pluginArr.push({
            ...item,
            configMapArr: []
          })
          this.pluginId.push(item.pluginId)
        })
        this.pluginArr.forEach((item) => {
          for (const k in item.configMap) {
            item.configMapArr.push({
              keyValue: k,
              keyName: k,
              val: item.configMap[k]
            })
          }
        })
      }
    },
    changeSelect(info) {
      this.pluginArr = []
      info.forEach((id) => {
        this.pluginDialogArr.forEach((item) => {
          if (id === item.pluginId) {
            this.pluginArr.push({
              ...item,
              configMapArr: []
            })
          }
        })
      })
      this.setPluginData()
    },
    setPluginData() {
      this.pluginArr.forEach((item) => {
        for (const k in item.configMap) {
          item.configMapArr.push({
            keyName: k,
            keyValue: item.configMap[k],
            val: ''
          })
        }
      })
    },
    removeTag(info) {
      this.pluginDialogArr.forEach((item, index) => {
        if (Number(info) === item.pluginId) {
          this.pluginArr.slice(0, index)
        }
      })
    },
    checkDesc(info) {
      // window.open(info)
    },
    getPlugin() {
      queryAllSdkPlugin().then((data) => {
        this.pluginDialogArr = data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.plugin-cont) {
  overflow: hidden;
  li {
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 10px;
  }
  p.plugin-name {
    padding: 0 20px 10px;
    line-height: 30px;
    overflow: hidden;
    font-size: 14px;
  }
  .info {
    .params-cont {
      padding-bottom: 10px;
      span {
        display: inline-block;
        width: 150px;
        padding-right: 10px;
        text-align: right;
      }
    }
  }
  .el-button {
    vertical-align: top;
    margin-left: 10px;
  }
}
p.title_label {
  margin-bottom: 10px;
  padding: 10px 0 20px 20px;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
  line-height: 30px;
  b {
    margin-right: 10px;
    font-size: 16px;
  }
}
</style>
